import { useMemo } from 'react';
import { ProgramItem } from '@/widgets/ProgramItem';
import { getTeacherCourseGroups, ITeacherCoursesResponse } from '@/entities/TeacherCourses';
import { COURSE_TYPE } from '@/shared/constants/courseData';

interface TeacherProgrammesProps {
  courses?: ITeacherCoursesResponse;
}

export const TeacherProgrammes = ({ courses }: TeacherProgrammesProps) => {
  const allCourses = useMemo(
    () =>
      getTeacherCourseGroups(courses).flatMap((group) =>
        group.courses.map((course) => ({ ...course, type: group.type })),
      ),
    [courses],
  );

  if (!courses) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-4">
      <h2 className="text-[32px] font-medium">My programmes</h2>
      {allCourses.length > 0 ? (
        <ul className="grid grid-cols-3 gap-4">
          {allCourses.map((course) => {
            let user;
            if (course.leadTeacher) {
              user = {
                avatar: course.leadTeacher.avatar,
                userName: course.leadTeacher.username,
                href: `/staff/${course.leadTeacher.id}`,
              };
            }

            return (
              <li key={course.id}>
                <ProgramItem
                  courseItem={{
                    typeCourse: COURSE_TYPE[course.type],
                    title: course.title,
                    user,
                    href: `/teacher/courses/${course.id}`,
                  }}
                />
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="flex items-center justify-center py-12">
          <p className="text-neutral-500">You don&apos;t have any programmes yet.</p>
        </div>
      )}
    </div>
  );
};
